import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/SocialIcons/DeleteIcon";
import { useFetchData } from "../../../hooks/useFetchData";
import { getGroupManagementUserGroupActionHandler } from "../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { groupManagement } from "../../../utils/mainTabs/admin/groupManagement/groupManagement";
import { useSelector } from "react-redux";
import CreateGroupModal from "./CreateGroup/CreateGroupModal";
import DeleteGroup from "./DeleteGroup/DeleteGroup";
import classes from "./GroupManagement.module.scss";
import ManageUserGroup from "./ManageGroup/ManageGroup";
import { FormattedMessage } from "react-intl";
import AddUserModal from "./AddUserModal/AddUserModal";
import { useDispatch } from "react-redux";

const GroupManagement = () => {
  const { setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName } =
    useOutletContext();
  const pageSize = 8;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const param = useParams();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [tableColumns, setTableColumns] = useState([]);
  const { columns, searchPlaceHolder } = groupManagement;
  const [createGroupModal, setCreateGroupModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [deleteGroupModal, setDeleteGroupModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getGroupManagementUserGroupActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = columns(navigate, tenantName, dispatch);
    setTableColumns(newTableColumns);
  }, [columns, navigate, tenantName, dispatch]);

  useEffect(() => {
    setAdminHeader("");
    setAdminTiles([]);
    setAdminNavLinks(
      groupManagement.navLinks(navigate, tenantName, handleSearchQuery)
    );
  }, [navigate, setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName]);

  useEffect(() => {
    if (data) {
      const selectedData = data?.filter((e) => e?.checked === true);
      const unSelectedData = [];
      data?.forEach((e) => {
        if (e?.checked === false) unSelectedData.push(e?.UserGroupId);
      });

      setSelectedRowData((prevData) => {
        const newData = [...prevData, ...selectedData];
        const uniqueData = Array.from(
          new Set(newData.map((item) => item.UserGroupId))
        ).map((id) => newData.find((item) => item.UserGroupId === id));
        // Remove items from uniqueData that are in unSelectedData
        const filteredUniqueData = uniqueData.filter(
          (item) => !unSelectedData.includes(item.UserGroupId)
        );

        return filteredUniqueData;
      });
    }
  }, [data]);
  return param?.userGroupId ? (
    <ManageUserGroup
      tenantName={tenantName}
      handleSearchQuery={handleSearchQuery}
    />
  ) : (
    <>
      <div className={classes.groupManagement}>
        <div className={classes.tableHeading}>
          <div className={classes.left}>
            <span className={classes.totalGroup}>
              {totalRows} <FormattedMessage id="GROUPS_TEXT" />
            </span>
          </div>
          <div className={classes.right}>
            <div
              className={classes.addNewUserGroup}
              onClick={() => setCreateGroupModal(true)}
            >
              <AddIcon fill={colors.theme} />
              <span className={classes.text}>
                <FormattedMessage id="USERGROUP_ADDUSERGRPBTN" />
              </span>
            </div>
            <div
              className={classes.deleteUserGroup}
              onClick={() => {
                if (selectedRowData?.length > 0) setDeleteGroupModal(true);
              }}
            >
              <DeleteIcon
                fill={selectedRowData?.length > 0 ? colors.theme : "#b9b9b9"}
              />
              <span
                className={
                  selectedRowData?.length > 0
                    ? classes.text
                    : classes.disableText
                }
              >
                <FormattedMessage id="USERGROUP_DELETEUSERGRPBTN" />
              </span>
            </div>
          </div>
        </div>
        <DataTable
          columns={tableColumns}
          defaultData={data}
          setDefaultData={setData}
          data={updatedData}
          setData={setUpdatedData}
          totalRows={totalRows}
          loading={loading}
          uniqueFieldName={"UserGroupId"}
          isFooter={false}
          selectableRows
          searchable
          placeholder={searchPlaceHolder}
          fetchMoreData={handleCurrentPage}
          setSearchQuery={handleSearchQuery}
        />
      </div>
      {createGroupModal && (
        <CreateGroupModal
          createGroupModal={createGroupModal}
          setCreateGroupModal={setCreateGroupModal}
          handleSearchQuery={handleSearchQuery}
          setAddUserModal={setAddUserModal}
        />
      )}
      {deleteGroupModal && (
        <DeleteGroup
          deleteGroupModal={deleteGroupModal}
          setDeleteGroupModal={setDeleteGroupModal}
          selectedRowData={selectedRowData}
          handleSearchQuery={handleSearchQuery}
          setSelectedRowData={setSelectedRowData}
        />
      )}
      {addUserModal && (
        <AddUserModal
          addUserModal={addUserModal}
          setAddUserModal={setAddUserModal}
          navigate={navigate}
          tenantName={tenantName}
          groupData={data}
        />
      )}
    </>
  );
};

export default GroupManagement;
